import img_1101EG from './1101EG.png';
import img_1102EG from './1102EG.png';
import img_1103EG from './1103EG.png';
import img_1104EG from './1104EG.png';

export const edelstahlgelaender = [
    {product_img: img_1101EG, titel: 'Modell - 1101EG'},
    {product_img: img_1102EG, titel: 'Modell - 1102EG'},
    {product_img: img_1103EG, titel: 'Modell - 1103EG'},
    {product_img: img_1104EG, titel: 'Modell - 1104EG'}
]